import { useState } from 'react';
import { Controller } from 'react-hook-form';
import {
  InputText,
  SelectSize,
  InputSize,
  Autocomplete,
  Select,
  PermissionEnum,
  IconUp,
  IconDown,
} from '@ui/src';
import { useAppSelector } from '@store';
import CreateFormRow from '../../partial/create/create-form-row';
import { CorporateCustomerCreateFormTypes } from '../types';

import cn from '../../partial/create/create.module.css';

const CorporateCustomerCreateForm = ({
  control,
  errors,
  applicationSchemes,
  activePermissions,
}: CorporateCustomerCreateFormTypes) => {
  const [applicationSchemeVisible, setApplicationSchemeVisible] =
    useState(false);

  const { countries, deliveryChannelsCorporate } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  return (
    <div className={cn.form}>
      <div className={cn.formTitle}>Country and Name</div>
      <CreateFormRow title="Country of incorporation of the company">
        <Controller
          control={control}
          name="countryOfIncorporationId"
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <Autocomplete
              name="countryOfIncorporationId"
              placeholder="Select country..."
              list={countries || []}
              value={value}
              className={`${cn.createIndividualAutocomplete} ${
                errors?.countryOfIncorporationId?.message ? cn.inputError : ''
              }`}
              size={SelectSize.SMALL}
              onChange={onChange}
              tabIndex={0}
              error={errors?.countryOfIncorporationId?.message}
              withClearButton
              borderless
            />
          )}
        />
      </CreateFormRow>
      <CreateFormRow title="Company name">
        <Controller
          control={control}
          name="companyName"
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <InputText
              name="companyName"
              className="borderless"
              placeholder="Enter company name"
              onChange={onChange}
              value={value}
              tabIndex={0}
              labelClassName={errors?.companyName?.message ? cn.inputError : ''}
              error={errors?.companyName?.message}
              size={InputSize.SMALL}
            />
          )}
        />
      </CreateFormRow>
      <CreateFormRow title="Delivery channels" id="deliveryChannelId">
        <Controller
          control={control}
          name="deliveryChannelId"
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <Select
              name="deliveryChannelId"
              placeholder="Select an option"
              list={deliveryChannelsCorporate}
              value={value}
              size={SelectSize.SMALL}
              onChange={onChange}
              tabIndex={0}
              error={errors?.deliveryChannelId?.message}
              withClearButton
              borderless
            />
          )}
        />
      </CreateFormRow>
      <button
        type="button"
        className={`${cn.formTitle} ${cn.formTitleButton}`}
        onClick={() => setApplicationSchemeVisible(!applicationSchemeVisible)}
      >
        {applicationSchemeVisible ? <IconUp /> : <IconDown />}
        Application Scheme
      </button>
      {applicationSchemeVisible &&
        activePermissions?.includes(
          PermissionEnum.APPLICATIONS_SCHEMES_LIST,
        ) && (
          <CreateFormRow title="Corporate scheme" id="applicationSchemeId">
            <Controller
              control={control}
              name="applicationSchemeId"
              defaultValue=""
              render={({ field: { onChange, value } }) => (
                <Select
                  name="applicationSchemeId"
                  placeholder="Select an option"
                  list={applicationSchemes?.map((item) => ({
                    name: item.name,
                    value: item.id,
                  }))}
                  value={value}
                  size={SelectSize.SMALL}
                  onChange={onChange}
                  tabIndex={0}
                  error={errors?.applicationSchemeId?.message}
                  withClearButton
                  borderless
                />
              )}
            />
          </CreateFormRow>
        )}
      {applicationSchemeVisible &&
        !activePermissions?.includes(
          PermissionEnum.APPLICATIONS_SCHEMES_LIST,
        ) && (
          <div className={cn.applicationSchemeDenied}>
            You don`t have access to this section
          </div>
        )}
    </div>
  );
};

export default CorporateCustomerCreateForm;
